import { render, staticRenderFns } from "./CheckList.vue?vue&type=template&id=a2f88df2&lang=pug"
import script from "./CheckList.vue?vue&type=script&lang=js"
export * from "./CheckList.vue?vue&type=script&lang=js"
import style0 from "./CheckList.vue?vue&type=style&index=0&id=a2f88df2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports